// Every number the alignments use (docs/02-Game-Design/Alignments.md), in one
// place so retuning is one edit and the copy in each file reads from it.
export const ALIGNMENT_NUMBERS = {
  // Mercury
  retrogradePercent: 100,
  crossroadsBranches: 1,
  suretyPercent: 20,
  suretyStep: 2,
  seeingDoublePercent: 300,
  perceptionLength: 5,
  perceptionPercent: 80,
  // Venus
  mellifluenceAdd: 5,
  firstImpressionPercent: 50,
  symmetryPercent: 100,
  embraceLoopPercent: 200,
  climaxPercent: 200,
  // Mars
  collateralEach: 35,
  volatilityPercent: 50,
  volatilityStars: 5,
  wrathAdd: 10,
  javelinBranches: 2,
  javelinPercent: 75,
  ultimatumPercent: 35,
  // Jupiter
  enormityLength: 8,
  enormityPercent: 50,
  elitismCount: 3,
  elitismPercent: 50,
  breadthAdd: 25,
  greatRedSpotPercent: 300,
  // Saturn
  orderlinessPercent: 200,
  capabilityPercent: 50,
  foundationsLength: 4,
  foundationsPercent: 100,
  disciplinePercent: 20,
  disciplineStep: 5,
  balancePercent: 50,
  // Uranus
  diversityPercent: 25,
  raritiesBase: 30,
  raritiesPercent: 100,
  cacophonyPercent: 50,
  explosivenessPercent: 200,
  uniquenessPercent: 50,
  // Neptune
  sacrificePercent: 25,
  depthPercent: 100,
  solitudeEach: 50,
  tridentBranches: 3,
  tridentPercent: 50,
  abyssAdd: 15,
  /** The bottom third of the sky starts here, as a fraction of its height. */
  abyssFrom: 2 / 3,
  // Pluto
  beginningsAndEndsPercent: 100,
  underdogLength: 3,
  underdogPercent: 200,
  farReachesEdge: 150,
  farReachesPercent: 100,
  richesBase: 20,
} as const;
